const testimonials = [
  {
    title: 'Sıfır Kesinti',
    quote:
      '"Sanal ortamımızın tamamını VergeOS\'a sıfır kesinti ile taşıdık. Migrasyon araçları sayesinde altı aylık bir proje birkaç güne indi."',
    name: 'Alinsco Insurance',
    sub: 'Farklı bir Sanallaştırma Platformundan VergeOS\'a Geçiş',
  },
  {
    title: '%85 Maliyet Azalması',
    quote:
      '"Mevcut sunucuları yeniden kullanarak ve ayrı depolama ile yedekleme lisanslarını kaldırarak, daha önce sahip olmadığımız yetenekler kazanırken altyapı giderlerimizi %85 düşürdük."',
    name: 'Pfeiffer University',
    sub: 'Altyapı Modernizasyonu',
  },
  {
    title: '4x Tekilleştirme',
    quote:
      '"Global tekilleştirme olağanüstü. Ortamımız genelinde 4:1 oranlar görüyoruz; bu da mevcut depolama alanımızın eskisinden çok daha verimli kullanıldığı anlamına geliyor."',
    name: 'Girtz Industries',
    sub: '',
  },
];

export default function CustomerResultsSection() {
  return (
    <section className="bg-[#f8fafc] py-16 px-6 border-b border-gray-100">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-12">
          <p className="text-xs font-bold text-[#e8600a] uppercase tracking-widest mb-2">Müşteri Sonuçları</p>
          <h2 className="text-3xl font-bold text-[#1a1a2e] mb-3">Ölçülen Etki</h2>
          <p className="text-sm text-[#64748b]">
            <strong className="text-[#e8600a]">VergeOS</strong>'a geçen kuruluşların gerçek çıktıları
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t) => (
            <div key={t.title} className="bg-white border border-gray-100 rounded-lg p-6 flex flex-col">
              <h3 className="text-xl font-bold text-[#e8600a] mb-4">{t.title}</h3>
              <p className="text-sm text-[#374151] leading-relaxed italic flex-1">{t.quote}</p>
              <div className="mt-6 pt-4 border-t border-gray-100">
                <p className="text-sm font-semibold text-[#1a1a2e]">{t.name}</p>
                <p className="text-xs text-[#94a3b8] mt-0.5">{t.sub}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
